module.exports = __webpack_public_path__ + "img/desktop/Menus-betmenu/btn-settings-selected@1x.png?0.0.53";